import { repository } from '../../data'
import type { View } from './derive'
import { ruleWhat, ruleWho } from './derive'
import { useArm, useWrite } from './parts'

const HOUR = 3_600_000

function left(expiresAt: string, now: string): { text: string; soon: boolean } {
  const ms = Date.parse(expiresAt) - Date.parse(now)
  const when = new Date(expiresAt).toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' })
  if (ms < 24 * HOUR) return { text: `Ends in ${Math.max(1, Math.round(ms / HOUR))} h`, soon: true }
  return { text: `Until ${when} · ${Math.round(ms / (24 * HOUR))} days left`, soon: false }
}

/** Access that ends: who, to what, and how long is left. It ends on its own. */
export function DirectList({ view }: { view: View }): JSX.Element {
  const arm = useArm()
  const end = useWrite(
    (ruleId: string) => repository.endRule(ruleId),
    (ruleId) => {
      const r = view.rules.find((x) => x.id === ruleId)
      return r ? `${ruleWho(view, r)} can no longer SSH into ${ruleWhat(view, r)} · sessions closed` : 'Ended'
    },
  )
  return (
    <section className="cx-panel cx-panel--padded" aria-label="Access that ends">
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <h2 className="cx-panel__title">Access that ends</h2>
        <span className="muted cx-small">Ends on its own</span>
      </div>
      {view.ending.length === 0 ? <p className="muted">None right now. Give access “for a while” to put some here.</p> : null}
      <ul className="cx-list">
        {view.ending.map((r) => {
          const t = left(r.expiresAt as string, view.now)
          return (
            <li key={r.id} className={`cx-direct ${t.soon ? 'is-soon' : ''}`}>
              <span className="stack" style={{ gap: 2, minWidth: 0 }}>
                <span className="cx-direct__who">
                  {ruleWho(view, r)} → <span className="cx-mono">{ruleWhat(view, r)}</span>
                  {r.level === 'restricted' ? <span className="muted"> · restricted</span> : null}
                </span>
                <span className="cx-direct__when">{t.text}</span>
              </span>
              <button className={arm.armed(r.id) ? 'danger is-armed' : 'danger'} disabled={end.pending} onClick={() => arm.press(r.id, () => end.run(r.id))}>
                {arm.armed(r.id) ? 'Sure?' : 'End now'}
              </button>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
